export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_META_DATA_INFO = 'SET_META_DATA_INFO';
